import { render, staticRenderFns } from "./customergroup.vue?vue&type=template&id=66305068&scoped=true&"
import script from "./customergroup.vue?vue&type=script&lang=js&"
export * from "./customergroup.vue?vue&type=script&lang=js&"
import style0 from "./customergroup.vue?vue&type=style&index=0&id=66305068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66305068",
  null
  
)

export default component.exports